import React from "react";
import SensorDataDiagramSettings from "../features/sensorDataDiagramSettings/sensorDataDiagramSettings";

export default function SensorDataDiagramSettingsPage() {


    return (
        <SensorDataDiagramSettings />
    )
}